import PropTypes from 'prop-types';
import React from 'react';
import { ArrowRightShort } from 'react-bootstrap-icons';

import useGroup from '../../hooks/use_group';
import useMarker from '../../hooks/use_marker';
import Btn from '../framework/buttons/btn';
import BodyListItem from './list-item';

const MarkerList = ({ col = 6, groups, listItemSize }) => {
	const { items: groups_data } = useGroup({ include_types: ['marker'] });
	const { items: markers } = useMarker({ include_types: ['body'] });

	return (
		<section id="markers">
			{groups_data
				.filter((group) => {
					return (groups && groups.includes(group.group_id)) ?? true;
				})
				.map((group, index1) => {
					const markers_filtered = markers.filter((marker) => {
						return marker.groups.includes(group.group_id);
					});
					if (!markers_filtered || !markers_filtered.length) return;

					const marker_list = markers_filtered.map((marker, index2) => {
						return (
							<div
								className={`col-lg-${col} pe-lg-0 mb-lg-2 mb-1`}
								key={index2}
							>
								<BodyListItem
									excerpt={marker.marker_variant.excerpt}
									groups={marker.groups}
									marker_id={marker.marker_id}
									size={listItemSize}
									slug={marker.marker_variant.slug}
									subtitle={marker.marker_variant.subtitle}
									title={marker.marker_variant.title}
								/>
							</div>
						);
					});

					if (!marker_list || !marker_list.length) return;

					return (
						<div className="marker-list-group" key={index1}>
							{(!groups || (groups && groups.length > 1)) && (
								<>
									<div className="d-flex align-items-center mb-2 gap-2">
										{/*}
										{group.group_variant.image && (
											<img
												alt={group.group_variant.title}
												className=" thumb-sm"
												src={group.group_variant.image}
											/>
										)}
										*/}

										<Btn
											className=" text-dark"
											component="group_link"
											groups={[group.group_id]}
											labelType="h2"
											page="kroppen"
											rightSection={<ArrowRightShort className="thumb-sm" />}
											size="title_small"
											variant="link"
										>
											{group.group_variant.title}
										</Btn>
									</div>
								</>
							)}
							<div className="row">{marker_list}</div>
						</div>
					);
				})}
		</section>
	);
};

MarkerList.propTypes = {
	col: PropTypes.number,
	groups: PropTypes.array,
	listItemSize: PropTypes.string,
};

export default MarkerList;
